import { render, staticRenderFns } from "./ProjectColor.vue?vue&type=template&id=29a72eb7&"
import script from "./ProjectColor.vue?vue&type=script&lang=js&"
export * from "./ProjectColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a72eb7')) {
      api.createRecord('29a72eb7', component.options)
    } else {
      api.reload('29a72eb7', component.options)
    }
    module.hot.accept("./ProjectColor.vue?vue&type=template&id=29a72eb7&", function () {
      api.rerender('29a72eb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectColor.vue"
export default component.exports